import * as React from "react"
import ContratoGrid from "./ContratoGrid"
import ContratoTopo from "./topo";
import ContratoDataset from '../../components/data/ContratoDataSet';

import IconButton from "@mui/material/IconButton";
import { Tooltip } from "@mui/material";
import NewIcon from "@mui/icons-material/InsertDriveFile";
import { Navigate, useNavigate } from 'react-router-dom';

/* LOCALIZAÇÃO */

import { format } from 'date-fns';
import { pt } from 'date-fns/locale';
import UsuarioDataset from "../../components/data/UsuarioDataSet";
import Usuario from "../../components/classes/Usuario";
import { UserContext } from "../../App";
import Utils from "../../helper/utils";

import styles from './detail.module.css';

import { useTranslation } from "react-i18next";

const RelacaoDeContrato = () => {
    const { t } = useTranslation();

    Utils.setDocumentTitle(t("pages.contracts.titlePage"));

    const user: any = React.useContext(UserContext);
    const navigate = useNavigate();

    const HandleDialogNew = () => {
        let dataContrato: ContratoDataset = new ContratoDataset();
        dataContrato.LimparObjetoDoCache();
        navigate('/contrato/detalhe');
    }

    return (
        <div className={`container ${styles.container}`}>
            <div className="containerTitle"><ContratoTopo {...{ title: 'Relação de Contratos' }} /></div>
            <div className="containerToolbar">
                <Tooltip title={t("pages.contracts.text.newContract")}>
                    <span>
                        <IconButton
                            onClick={HandleDialogNew}
                            disabled={user.isParceiro || user.isSuporte}
                        >
                            <NewIcon /></IconButton>
                    </span>
                </Tooltip>
            </div>
            <ContratoGrid {...{ data: null }} />
        </div>
    );
}

export default RelacaoDeContrato;